import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '@mui/material';
import { trakrefBlue, focusColor } from '../../../color_utils';
import { trakrefFontFamilyBold } from '../../../utils';

const largeButtonTextStyle = {
    padding: '1.5% 0%',
    color: trakrefBlue,
    fontSize: '16px',
    fontFamily: trakrefFontFamilyBold,
    letterSpacing: '1px',
};

const SecondaryButton = ({
    id,
    buttonText,
    onClick,
    disabled,
    fullWidth,
    useLargeButton,
    useSmallButton,
    width,
    isTextVariant,
    startIcon,
    buttonColor,
    sx
}) => {

    if (useLargeButton) {
        return (
            <Button
                id={id}
                variant={isTextVariant ? "text" : "outlined"} 
                size="large"
                disabled={disabled}
                onClick={onClick}
                fullWidth={fullWidth}
                sx={{
                    width: `${width}%`,
                    height: '52px',
                    '&.MuiButton-outlined': {
                        color: buttonColor
                    },
                    '&.MuiButton-root': {
                        fontFamily: trakrefFontFamilyBold,
                        letterSpacing: '1.2px',
                        ...(!isTextVariant && ({ border: `1px solid ${buttonColor}` }) )
                    },
                    '&:focus': { outline: `3px solid ${focusColor}` },
                    ...sx
                }}
            >
                <Typography variant='h5' sx={largeButtonTextStyle}>
                    {buttonText}
                </Typography>
            </Button>
        );
    }

    if (useSmallButton) {
        return (
            <Button
                id={id}
                variant={isTextVariant ? "text" : "outlined"} 
                disabled={disabled}
                onClick={onClick}
                fullWidth={fullWidth}
                sx={{
                    width: `${width}%`,
                    '&.MuiButton-outlined': {
                        color: buttonColor
                    },
                    '&.MuiButton-root': {
                        fontFamily: trakrefFontFamilyBold,
                        letterSpacing: '1.2px',
                        fontSize: '12px',
                        opacity: disabled ? '40%' : '100%',
                        ...(!isTextVariant && ({ border: `1px solid ${buttonColor}` }))
                    },
                    ...sx
                }}
                startIcon={startIcon}
            >
                {buttonText}
            </Button>
        );
    }

    return (
        <Button
            id={id}
            variant={isTextVariant ? "text" : "outlined"} 
            disabled={disabled}
            onClick={onClick}
            fullWidth={fullWidth}
            sx={{
                width: `${width}%`,
                '&.MuiButton-outlined': {
                    color: buttonColor
                },
                '&.MuiButton-root': {
                    fontFamily: trakrefFontFamilyBold,
                    letterSpacing: '1.2px',
                    fontSize: { xs: '14px', md: '12px', lg: '14px' },
                    padding: { xs: '6px 16px', md: '4px 10px', lg: '6px 16px' },
                    opacity: disabled ? '40%' : '100%',
                    ...(!isTextVariant && ({ border: `1px solid ${buttonColor}` }))
                },
                ...sx
            }}
            startIcon={startIcon}
        >
            {buttonText}
        </Button>
    );
};

SecondaryButton.propTypes = {
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    useLargeButton: PropTypes.bool,
    id: PropTypes.string,
    width: PropTypes.number,
    isTextVariant: PropTypes.bool,
    startIcon: PropTypes.node,
    useSmallButton: PropTypes.bool,
    buttonColor: PropTypes.string,
    sx: PropTypes.object
};

SecondaryButton.defaultProps = {
    disabled: false,
    fullWidth: false,
    useLargeButton: false,
    id: "",
    width: null,
    isTextVariant: false,
    useSmallButton: false,
    buttonColor: trakrefBlue,
    sx: {},
};

export default SecondaryButton;
